// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 486) return "js/486.js";
	if (chunkId === 306) return "js/306.js";
	// return url for filenames based on template
	return undefined;
};